export default "/bundles/assets/logout_c772f83e26535ba05184a8df7ee0563a.png";